import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home/Home";
import Contact from "./components/pages/Contact/Contact";
import AboutPage from "./components/pages/Aboutpage/AboutPage";
import IndividualService from "./components/pages/services/IndividualService";
import ScrollTop from "./components/common/ScrollTop";
import ServicePage from "./components/pages/ServicePage/ServicePage";
import { ToastContainer } from "react-toastify";
import About2Page from "./components/pages/About2Page/About2Page";

function App() {
  return (
    <>
      <ScrollTop />
      <ToastContainer autoClose={4000} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/who-we-are" element={<AboutPage />} />
        <Route path="/about" element={<About2Page />} />
        <Route path="/what-we-do" element={<ServicePage />} />
        <Route path="/:service/:id" element={<IndividualService />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
